import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import FreeHotelRevenueAuditNoCostCompleteAnalysis from "../pages/FreeHotelRevenueAuditNoCostCompleteAnalysis/FreeHotelRevenueAuditNoCostCompleteAnalysis";
import "../index.css";
import "../pages/FreeHotelRevenueAuditNoCostCompleteAnalysis/FreeHotelRevenueAuditNoCostCompleteAnalysis.module.css";

type AnyProps = Record<string, any>;

let root:
| ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;


        function App(props: AnyProps) {
        const { router = "memory", basename, initialEntries, ...pageProps } = props;

        if (router === "memory") {
        return (
        <MemoryRouter initialEntries={initialEntries ?? ["/"]}>
        <FreeHotelRevenueAuditNoCostCompleteAnalysis {...(pageProps as any)} />
        </MemoryRouter>
        );
        }

        return (
        <BrowserRouter basename={basename}>
            <FreeHotelRevenueAuditNoCostCompleteAnalysis {...(pageProps as any)} />
        </BrowserRouter>
        );
        }

        function mount(el: HTMLElement, props: AnyProps = {}) {
        console.log("Rendering......")
        root = createRoot(el);
        root.render(<App {...props} />);
        }

        function hydrate(el: HTMLElement, props: AnyProps = {}) {
        console.log("Hydrating......")

        root = hydrateRoot(el, <App {...props} />);
        }

        function unmount() {
        root?.unmount?.();
        root = null;
        }

        if (typeof window !== "undefined")
        (window as any).FreeHotelRevenueAuditNoCostCompleteAnalysisVC = { mount, hydrate, unmount };